export const API_ENDPOINT = 'https://api.harrietalida.com'
export const DEV_API_ENDPOINT = 'http://localhost:4001'
export const STORAGE_KEY_PREFIX = 'HALF_'

export enum STORAGE_KEYS {
  AUTH_KEY = 'CID',
}
